var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block"},[_c('div',{staticClass:"fullscreen-btn",on:{"click":_vm.clickFullscreen}},[_c('svg-icon',{attrs:{"iconClass":_vm.fullscreen ? 'fullscreen-exit' : 'fullscreen',"className":"fullcreen-icon"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }